import React, {Fragment} from 'react';
import './AdminDashboardPageBody.scss';
import PageBodyWrapper from "root/PageBodyWrapper";

const AdminInboxPageBody = (props) =>
{
    return (
        <Fragment>
            <PageBodyWrapper title='Inbox'>
            <div className='manage-grid-rows'>
                {/*<TableAdminInbox data={data}/>*/}
                You have no items in your Inbox
            </div>
            </PageBodyWrapper>
        </Fragment>
    )

}

export default AdminInboxPageBody;
